import React from "react";

import styled from "styled-components";

import { fontSizes } from "../../styles";

// Styled-components for SSR CSS generation
const EyebrowStyled = styled.p({
    "fontSize": fontSizes.sm,
    "font-size": fontSizes.sm,
    "lineHeight": 1.25,
    "line-height": 1.25,
    "textTransform": "uppercase",
    "text-transform": "uppercase",
    "fontWeight": 700,
    "font-weight": 700,
    "marginBlockStart": 0,
    "margin-block-start": 0,
    "marginBlockEnd": "1rem",
    "margin-block-end": "1rem"
});

const HorizontalLineStyled = styled.hr({
    "marginTop": 0,
    "margin-top": 0
});

const TitlesContainerStyled = styled.div({
    "@media (min-width: 768px)": {
        textAlign: "left"
    }
});

export const TitlesContainer: React.FC<React.HTMLAttributes<HTMLDivElement>> = (
    props
) => {
    return <TitlesContainerStyled {...props} />;
};

const TitleStyled = styled.h2({
    "paddingBottom": "1rem",
    "@media (max-width: 767.98px)": {
        paddingBottom: "0.5rem"
    }
});

export const Title: React.FC<React.HTMLAttributes<HTMLHeadingElement>> = (
    props
) => {
    return ;
};

export const Eyebrow: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = (
    props
) => <EyebrowStyled {...props} />;

export const HorizontalLine: React.FC<React.HTMLAttributes<HTMLHRElement>> = (
    props
) => <HorizontalLineStyled role="presentation" {...props} />;

const BodyCopyStyled = styled.div({});

export const BodyCopy: React.FC<React.HTMLAttributes<HTMLDivElement>> = (
    props
) => {
    const className = `bodycopy-markdown ${props.className || ""}`;
    return <BodyCopyStyled {...props} className={className} />;
};

const CTAsStyled = styled.div({
    "@media (min-width: 768px)": {
        textAlign: "left"
    }
});

export const CTAs: React.FC<
    React.HTMLAttributes<HTMLDivElement> & { appearance?: string }
> = ({ appearance, ...props }) => {
    return <CTAsStyled {...props} />;
};
